import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { FRAGRANCE_FREE, NO_ADDED_FRAGRANCE, SOLSTICE } from 'constants/haircareFragrances';
import { productsSlugs } from 'constants/products';

import { getFragranceIngredients, getFragranceName } from 'utils/fragrances';

import Spacer from './Spacer';

const TextDescription = styled.span<{ color: Props['descriptionColor'] }>`
  ${({ color }) => {
    if (color === 'light') {
      return `
    color: ${theme.colors.neutral[800]};
    `;
    }
    return '';
  }}
`;

type Props = {
  product: {
    fragrance: string;
    fragrance_description?: string;
    fragrance_smells_like?: string;
    type: string;
  };
  descriptionColor?: 'light';
  spacerBefore?: number;
  spacerAfter?: number;
};

const FragranceDescription = ({
  product,
  descriptionColor = undefined,
  spacerBefore = undefined,
  spacerAfter = undefined,
}: Props) => {
  const { fragrance, fragrance_description, fragrance_smells_like, type: productSlug } = product;

  if (!fragrance_description) return null;
  if (
    !fragrance_smells_like &&
    (productSlug === productsSlugs.SUPPLEMENT_CORE ||
      productSlug === productsSlugs.SUPPLEMENTS_POUCH)
  ) {
    return null;
  }
  const isHairOil = productSlug === 'leavein';

  return (
    <>
      {spacerBefore && <Spacer axis="vertical" size={spacerBefore} />}
      {fragrance_smells_like ? (
        <span>
          Smells like: {fragrance_smells_like}
          {' — '}
          <TextDescription color={descriptionColor}>{fragrance_description}</TextDescription>
        </span>
      ) : (
        <span>
          {fragrance === NO_ADDED_FRAGRANCE
            ? 'No added fragrance'
            : `Your ${isHairOil ? 'Hair Oil' : ''} fragrance`}
          {' — '}
          <TextDescription color={descriptionColor}>
            {[NO_ADDED_FRAGRANCE, FRAGRANCE_FREE, SOLSTICE].includes(fragrance)
              ? fragrance_description
              : `${getFragranceName(fragrance)}, with notes of ${getFragranceIngredients(
                  fragrance,
                )}`}{' '}
          </TextDescription>
        </span>
      )}
      {spacerAfter && <Spacer axis="vertical" size={spacerAfter} />}
    </>
  );
};

export default FragranceDescription;
